import storeProxy from "./proxies/storeProxy";
import alertProxy from "./proxies/alertProxy";
import sensorProxy from "./proxies/sensorProxy";
import deviceProxy from "./proxies/deviceProxy";
import alertCommentProxy from "./proxies/alertCommentProxy";
import alertWorkOrderProxy from "./proxies/alertWorkOrderProxy";
import configurationProxy from "./proxies/configurationProxy";
import lightingConfigurationProxy from "./proxies/lightingConfigurationProxy";
import sceneProxy from "./proxies/sceneProxy";
import userRolesProxy from "./proxies/userRolesProxy";
import storeLightingProxy from "./proxies/storeLightingProxy";
import zoneProxy from "./proxies/zoneProxy";
import overrideProxy from "./proxies/overrideProxy";

const apiProxy = {
  store: storeProxy,
  alert: alertProxy,
  sensor: sensorProxy,
  device: deviceProxy,
  alertComment: alertCommentProxy,
  alertWorkOrder: alertWorkOrderProxy,
  configuration: configurationProxy,
  lightingConfiguration: lightingConfigurationProxy,
  scene: sceneProxy,
  userRoles: userRolesProxy,
  storeLighting: storeLightingProxy,
  zone: zoneProxy,
  override: overrideProxy
};

export default apiProxy;
